<template>
    <div id="responses-form">
        <form>
            <h5>{{trans('quiz-creator.answer_options')}}</h5>
            <div v-if="!['essay', 'reorder', 'reorder_images'].includes(type)"  v-for="(response, id) in responses" class="row">
                <div class="col-11">
                    <div class="d-table position-relative w-100 ">
                        <div class="form-check d-table-cell" style="width: 50px;" v-if="type != 'free_text'">
                            <input v-if="type=='multiple'" @change="change" v-model="responses[id].correct" class="form-check-input ml-auto mr-auto" type="checkbox" value="option1" :id="'input' + qId + questionId + id">
                            <input v-if="type=='single' || type=='true' " @change="change" v-model="correct" class="form-check-input ml-auto mr-auto" type="radio" name="radio" v-bind:value="id" :id="'input' + qId + questionId + id">
                            <label style="vertical-align: middle;" class="form-check-label" :for="'input' + qId + questionId + id">
                                &nbsp;
                            </label>
                        </div>
                        <div class="form-group d-table-cel">
                            <template v-if="type == 'true'">
                                <input disabled v-model="responses[id].text" type="hidden">
                                <input disabled :value="trans('quiz-creator.answers.' + responses[id].text)" type="text" class="form-control">
                            </template>
                            <template v-else>
                                <input @change="change" v-model="responses[id].text" type="text" class="form-control" :placeholder="trans('quiz-creator.answers.placeholder')">
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-1">
                    <i v-if="type!='true'" @click="remove(id)" class="fas fa-trash"></i>
                </div>
            </div>
            <template v-if="['reorder', 'reorder_images'].includes(type)">
                <draggable handle=".handle-response"
                           @change="change()"
                           :swapThreshold="0.5"
                           :scroll="true"
                           :scroll-speed="2000"
                           :scroll-sensitivity="10"
                           v-model="responses">
                    <div v-for="(response, id) in responses"  class="row">
                        <div class="col-1">
                            <div class="course-icon-wrap handle-response mt-3 hover-image">
                                <img :src="'/images/drag-grey.png'" loading="lazy" alt="" class="inactive-icon" style="opacity: 1;">
                                <img :src="'/images/drag-orange.png'" loading="lazy" alt="" class="active-icon" style="opacity: 0;">
                            </div>
                        </div>
                        <div class="col-10">
                            <div class="d-table position-relative w-100">
                                <div class="form-check d-table-cell" style="width: 50px;" v-if="['multiple', 'single', 'true'].includes(type)">
                                    <input v-if="type=='multiple'" @change="change" v-model="responses[id].correct" class="form-check-input ml-auto mr-auto" type="checkbox" id="inlineCheckbox1" value="option1" :id="'input' + qId + questionId + id">
                                    <input v-if="type=='single' || type=='true' " @change="change" v-model="correct" class="form-check-input ml-auto mr-auto" type="radio" name="radio" v-bind:value="id" :id="'input' + qId + questionId + id">
                                    <label style="vertical-align: middle;" class="form-check-label" :for="'input' + qId + questionId + id">
                                        &nbsp;
                                    </label>
                                </div>
                                <div class="form-group d-table-cel">
                                    <input  v-if="type=='reorder'" @change="change" v-model="responses[id].text" type="text" class="form-control" :placeholder="trans('quiz-creator.answers.placeholder')">
                                    <template v-if="type=='reorder_images'" >
                                        <img class="question-img" :src="responses[id].image+'?token='+token">
                                        <button @click="uploadTrigger(id)" type="button" class="image-upload-editor mt-2 mb-2">
                                                <i class="fas fa-upload"></i>
                                                {{trans('quiz-creator.upload_from_pc')}}
                                            </button>
                                            <button @click="choseFromLibrary(id)" type="button" class="image-upload-editor mt-2 mb-2">
                                                <i class="fas fa-upload"></i>
                                                {{trans('quiz-creator.chose_from_library')}}
                                            </button>
                                            <input  @change="uploadFile($event, id)" type="file" accept="image/*" style="display:none" name=""  :id="'file-input-'+id">
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-1">
                            <i v-if="type!='true'" @click="remove(id)" class="fas fa-trash"></i>
                        </div>
                    </div>
                </draggable>
            </template>
            <button v-if="type!='true' && type!='essay'"  type="button" @click="addNewOption" class="btn btn-success">{{trans('quiz-creator.add_answer_option')}}</button>
        </form>
        <div class="modal fade " id="libraryModal" tabindex="-1" role="dialog" aria-labelledby="libraryModalTitle" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="libraryModalTitle">{{trans('quiz-creator.library_modal_tile')}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                    <div class="col-12 form-inline w-100 mb-3">
                        <div class="mr-4">
                            <label class="justify-content-start" for="entries">{{trans('library.sort_by_name')}}</label>
                            <select @change="filterLibrary('name')"  v-model="filterName" class="form-control" name="name">
                                <option value="">{{trans('library.select_option')}}</option>
                                <option value="asc">{{trans('library.ascending')}} </option>
                                <option value="desc">{{trans('library.descending')}} </option>
                            </select>
                        </div>
                        <div>
                            <label class="justify-content-start" for="entries">{{trans('library.sort_by_size')}}</label>
                            <select @change="filterLibrary('size')" class="form-control" v-model="filterSize">
                                <option value="">{{trans('library.select_option')}}</option>
                                <option value="asc">{{trans('library.ascending')}} </option>
                                <option value="desc">{{trans('library.descending')}}</option>
                            </select>
                        </div>
                        <div class="ml-auto">
                            <input @input="searchLibrary()" class="form-control mr-sm-2" type="search" v-model="filterSearch" value="" :placeholder="trans('forms.search')" aria-label="Search by filename">
                            <button  @click="filterLibrary('search')" class="btn btn-outline-success my-2 my-sm-0" type="button">{{trans('library.search')}}</button>
                        </div>
                       <!--  <input type="hidden" name="view" value="{{$view}}">
                        <input type="hidden" name="user" value="{{$userFilter}}"> -->
                    </div>
                    <div v-if="typeof library[0] != 'undefined'" class="col-sm-3" v-for="file in library">
                        <div class="card mb-3 pointer" @click="selectFile(file)">
                            <img  class="card-img-top img-fluid img-library" :src="'/library/file/'+file.hash+'?token='
                            +token" alt="Card image cap">
                        </div>
                        <div class="card-body mt-0">
                            <label class="card-title">
                                {{file.path|fileNameFromUrl}}
                            </label>
                        </div>
                    </div>
                    <div class="col-12 text-center" v-if="showLoadMore">
                        <button type="button" @click='choseFromLibrary(libraryIdx, libraryPage)' class="btn btn-primary">{{trans('quiz-creator.library_modal_load_more')}}</button>
                    </div>
                    <div v-if="typeof library[0] == 'undefined'" class=" col-12 text-center mt-4 w-100">
                        <h3>{{trans('quiz-creator.library_modal_load_more_no_files')}}</h3>
                    </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{trans('quiz-creator.library_modal_close')}}</button>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    import draggable from "vuedraggable";

    export default {
        name: "responses-form",
        mounted() {
        },
        components: {
            draggable,
        },
        created() {
            this.getResponses(this.questionId);
        },
        props: {
           qId: Number,
           questionId: Number,
           type: String
        },
        data: function() {
            return {
                responses: [],
                token: null,

                /*this is used for library filters*/
                 library:[],
                libraryPage: 1,
                libraryIdx: null,
                filterName: '',
                filterSize: '',
                filterSearch: '',
                showLoadMore: true,

                defaultResponses: [
                    {text: this.type == 'true' ? 'True' : '', correct: true, image: '/images/content-preview.jpg'},
                    {text: this.type == 'true' ? 'False' : '', correct: false, image: '/images/content-preview.jpg'}
                ],
                correct: 0,
            }
        },
        methods: {
            addNewOption: function() {
                if (this.type == 'reorder_images') {
                    this.responses.push({image: '/images/content-preview.jpg'});
                    this.change();
                } else {
                    this.responses.push({text: '', correct: this.type === 'free_text'});
                }
            },
            remove(id) {
                this.responses.splice(id, 1);
                this.change();
            },
            getResponses: function() {
                let $end = '/api/question-responses/'+this.questionId;
                let self = this;

                axios.get($end).then(function (res) {
                    let response = res.data.responses;
                    self.token = res.data.token;
                    if (response) {
                        self.responses = response;
                    } else {
                        self.responses = self.defaultResponses;
                    }

                    if (self.type === 'free_text') {
                        self.responses.forEach((resp) => {
                            resp.correct = true;
                        });
                    }

                    if (self.type == 'true' || self.type == 'single') {
                        self.responses.forEach(function(question, id) {
                            if (question.correct) {
                                self.correct = id;
                            }
                        });
                    }

                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            },
            change: function() {
                let $end = '/api/save-questions';

                let self = this;
                if (this.type == 'true' || this.type == 'single') {
                    self.responses.forEach(function(question, id) {
                        self.responses[id].correct = self.correct == id ? true : false;
                    });
                }

                axios.post($end, {
                    responses: this.responses,
                    qid: this.qId,
                    questionId: this.questionId,
                    correct: this.questionId
                }).then(response  => {

                }).catch(err => {
                    this.$data.loader = false;
                });
            },
            uploadTrigger(id) {
                console.log(id);
                $('#file-input-'+id).trigger('click');
            },
            uploadFile(e, id) {
                const file = e.target.files[0];
                let $end = '/api/upload-editor-image';
                let data = new FormData();
                data.append('file', e.target.files[0]);
                data.append('type', 'image');

                axios.post($end, data).then(response  => {
                    this.loader = false;

                    this.responses[id].image = '/library/file/'+response.data.url;
                    this.change();
                }).catch(err => {
                    let errors = err.response.data.errors;
                    if (typeof errors != 'undefined') {
                        for (let field of Object.keys(errors)) {
                            //this.form.blocksData[id].error = errors[field][0];
                        }
                    }
                    this.$data.loader = false;
                });
            },
            choseFromLibrary: function(id, page=false) {
                let $end = '/api/library/images/true';
                let self = this;
                self.showLoadMore = true;

                this.libraryIdx = id;
                this.libraryType = 'image';

                let params = {};
                if (this.filterName) {
                    params.name = this.filterName;
                }
                if (this.filterSize) {
                    params.size = this.filterSize;
                }
                if (this.filterSearch){
                    params.search = this.filterSearch;
                }

                if (page) {
                    params.page = page+1;
                }

                this.currentLibraryId = id;
                this.currentLibraryColumn = 'image';
                axios.get($end, {
                    params:params
                }).then(function (res) {
                    let response = res.data;
                    self.libraryPage = response.files.current_page;

                    if ( self.libraryPage == response.files.last_page) {
                        self.showLoadMore =  false;
                    }

                   if (page) {
                        self.library = [...self.library, ...response.files.data];
                   } else {
                        self.library = response.files.data;
                   }
                    $('#libraryModal').modal('show');

                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            },
            searchLibrary: function () {
                if (this.filterSearch.length >= 2 || this.filterSearch.length === 0) {
                    this.filterLibrary("search")
                }
            },
            filterLibrary: function(type) {
                if (type == 'name') {
                    this.filterSize = '';
                }
                if (type == 'size') {
                    this.filterName = '';
                }
                this.choseFromLibrary(this.libraryIdx)
            },
            selectFile: function(file) {
                this.responses[this.currentLibraryId].image = '/library/file/'+file.hash;
                this.change();
                $('#libraryModal').modal('hide');
            },
        }
    }
</script>
<style type="text/css">
</style>
